/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { GeneratedRoute } from '@elegant-router/types';

export const generatedRoutes: GeneratedRoute[] = [
  {
    name: '403',
    path: '/403',
    component: 'layout.base$view.403',
    meta: {
      title: '403',
      i18nKey: 'route.403',
      constant: true
    }
  },
  {
    name: '404',
    path: '/404',
    component: 'layout.base$view.404',
    meta: {
      title: '404',
      i18nKey: 'route.404',
      constant: true
    }
  },
  {
    name: '500',
    path: '/500',
    component: 'layout.base$view.500',
    meta: {
      title: '500',
      i18nKey: 'route.500',
      constant: true
    }
  },
  {
    name: 'appointment',
    path: '/appointment',
    component: 'layout.base',
    meta: {
      title: 'appointment',
      i18nKey: 'route.appointment'
    },
    children: [
      {
        name: 'appointment_appointment-audit',
        path: '/appointment/appointment-audit',
        component: 'view.appointment_appointment-audit',
        meta: {
          title: 'appointment_appointment-audit',
          i18nKey: 'route.appointment_appointment-audit'
        }
      },
      {
        name: 'appointment_appointment-distribution',
        path: '/appointment/appointment-distribution',
        component: 'view.appointment_appointment-distribution',
        meta: {
          title: 'appointment_appointment-distribution',
          i18nKey: 'route.appointment_appointment-distribution'
        }
      },
      {
        name: 'appointment_appointment-info',
        path: '/appointment/appointment-info',
        component: 'view.appointment_appointment-info',
        meta: {
          title: 'appointment_appointment-info',
          i18nKey: 'route.appointment_appointment-info'
        }
      },
      {
        name: 'appointment_appointment-loss',
        path: '/appointment/appointment-loss',
        component: 'view.appointment_appointment-loss',
        meta: {
          title: 'appointment_appointment-loss',
          i18nKey: 'route.appointment_appointment-loss'
        }
      }
    ]
  },
  {
    name: 'attachment',
    path: '/attachment',
    component: 'layout.base$view.attachment',
    meta: {
      title: 'attachment',
      i18nKey: 'route.attachment'
    }
  },
  {
    name: 'base',
    path: '/base',
    component: 'layout.base',
    meta: {
      title: 'base',
      i18nKey: 'route.base'
    },
    children: [
      {
        name: 'base_product-info',
        path: '/base/product-info',
        component: 'view.base_product-info',
        meta: {
          title: 'base_product-info',
          i18nKey: 'route.base_product-info'
        }
      },
      {
        name: 'base_product-sku',
        path: '/base/product-sku',
        component: 'view.base_product-sku',
        meta: {
          title: 'base_product-sku',
          i18nKey: 'route.base_product-sku'
        }
      },
      {
        name: 'base_product-spu',
        path: '/base/product-spu',
        component: 'view.base_product-spu',
        meta: {
          title: 'base_product-spu',
          i18nKey: 'route.base_product-spu'
        }
      },
      {
        name: 'base_vehicle-brand',
        path: '/base/vehicle-brand',
        component: 'view.base_vehicle-brand',
        meta: {
          title: 'base_vehicle-brand',
          i18nKey: 'route.base_vehicle-brand'
        }
      },
      {
        name: 'base_vehicle-info',
        path: '/base/vehicle-info',
        component: 'view.base_vehicle-info',
        meta: {
          title: 'base_vehicle-info',
          i18nKey: 'route.base_vehicle-info'
        }
      },
      {
        name: 'base_vehicle-oem',
        path: '/base/vehicle-oem',
        component: 'view.base_vehicle-oem',
        meta: {
          title: 'base_vehicle-oem',
          i18nKey: 'route.base_vehicle-oem'
        }
      },
      {
        name: 'base_vehicle-series',
        path: '/base/vehicle-series',
        component: 'view.base_vehicle-series',
        meta: {
          title: 'base_vehicle-series',
          i18nKey: 'route.base_vehicle-series'
        }
      },
      {
        name: 'base_warehouse',
        path: '/base/warehouse',
        component: 'view.base_warehouse',
        meta: {
          title: 'base_warehouse',
          i18nKey: 'route.base_warehouse'
        }
      }
    ]
  },
  {
    name: 'certified-technician',
    path: '/certified-technician',
    component: 'layout.base$view.certified-technician',
    meta: {
      title: 'certified-technician',
      i18nKey: 'route.certified-technician'
    }
  },
  {
    name: 'customer-info',
    path: '/customer-info',
    component: 'layout.base$view.customer-info',
    meta: {
      title: 'customer-info',
      i18nKey: 'route.customer-info'
    }
  },
  {
    name: 'display-case',
    path: '/display-case',
    component: 'layout.base$view.display-case',
    meta: {
      title: 'display-case',
      i18nKey: 'route.display-case'
    }
  },
  {
    name: 'finance',
    path: '/finance',
    component: 'layout.base',
    meta: {
      title: 'finance',
      i18nKey: 'route.finance'
    },
    children: [
      {
        name: 'finance_film-quotation',
        path: '/finance/film-quotation',
        component: 'view.finance_film-quotation',
        meta: {
          title: 'finance_film-quotation',
          i18nKey: 'route.finance_film-quotation'
        }
      },
      {
        name: 'finance_finance-commission-details',
        path: '/finance/finance-commission-details',
        component: 'view.finance_finance-commission-details',
        meta: {
          title: 'finance_finance-commission-details',
          i18nKey: 'route.finance_finance-commission-details'
        }
      },
      {
        name: 'finance_finance-sale-plan',
        path: '/finance/finance-sale-plan',
        component: 'view.finance_finance-sale-plan',
        meta: {
          title: 'finance_finance-sale-plan',
          i18nKey: 'route.finance_finance-sale-plan'
        }
      },
      {
        name: 'finance_finance-transaction-record',
        path: '/finance/finance-transaction-record',
        component: 'view.finance_finance-transaction-record',
        meta: {
          title: 'finance_finance-transaction-record',
          i18nKey: 'route.finance_finance-transaction-record'
        }
      },
      {
        name: 'finance_finance-wallet',
        path: '/finance/finance-wallet',
        component: 'view.finance_finance-wallet',
        meta: {
          title: 'finance_finance-wallet',
          i18nKey: 'route.finance_finance-wallet'
        }
      },
      {
        name: 'finance_partner-commission-record',
        path: '/finance/partner-commission-record',
        component: 'view.finance_partner-commission-record',
        meta: {
          title: 'finance_partner-commission-record',
          i18nKey: 'route.finance_partner-commission-record'
        }
      },
      {
        name: 'finance_sale',
        path: '/finance/sale',
        meta: {
          title: 'finance_sale',
          i18nKey: 'route.finance_sale'
        },
        children: [
          {
            name: 'finance_sale_order',
            path: '/finance/sale/order',
            meta: {
              title: 'finance_sale_order',
              i18nKey: 'route.finance_sale_order'
            },
            children: [
              {
                name: 'finance_sale_order_commission',
                path: '/finance/sale/order/commission',
                meta: {
                  title: 'finance_sale_order_commission',
                  i18nKey: 'route.finance_sale_order_commission'
                },
                children: [
                  {
                    name: 'finance_sale_order_commission_record',
                    path: '/finance/sale/order/commission/record',
                    component: 'view.finance_sale_order_commission_record',
                    meta: {
                      title: 'finance_sale_order_commission_record',
                      i18nKey: 'route.finance_sale_order_commission_record'
                    }
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        name: 'finance_sale-order-technician-commission',
        path: '/finance/sale-order-technician-commission',
        component: 'view.finance_sale-order-technician-commission',
        meta: {
          title: 'finance_sale-order-technician-commission',
          i18nKey: 'route.finance_sale-order-technician-commission'
        }
      }
    ]
  },
  {
    name: 'general-form',
    path: '/general-form/:config',
    component: 'layout.base$view.general-form',
    props: true,
    meta: {
      title: 'general-form',
      i18nKey: 'route.general-form',
      multiTab: true,
      hideInMenu: true
    }
  },
  {
    name: 'home',
    path: '/home',
    component: 'layout.base$view.home',
    meta: {
      title: 'home',
      i18nKey: 'route.home'
    }
  },
  {
    name: 'iframe-page',
    path: '/iframe-page/:url',
    component: 'layout.base$view.iframe-page',
    props: true,
    meta: {
      title: 'iframe-page',
      i18nKey: 'route.iframe-page',
      multiTab: true,
      hideInMenu: true
    }
  },
  {
    name: 'inventory',
    path: '/inventory',
    component: 'layout.base',
    meta: {
      title: 'inventory',
      i18nKey: 'route.inventory'
    },
    children: [
      {
        name: 'inventory_circulating-inventory-info',
        path: '/inventory/circulating-inventory-info',
        component: 'view.inventory_circulating-inventory-info',
        meta: {
          title: 'inventory_circulating-inventory-info',
          i18nKey: 'route.inventory_circulating-inventory-info'
        }
      },
      {
        name: 'inventory_inventory-allocated-record',
        path: '/inventory/inventory-allocated-record',
        component: 'view.inventory_inventory-allocated-record',
        meta: {
          title: 'inventory_inventory-allocated-record',
          i18nKey: 'route.inventory_inventory-allocated-record'
        }
      },
      {
        name: 'inventory_inventory-check-record',
        path: '/inventory/inventory-check-record',
        component: 'view.inventory_inventory-check-record',
        meta: {
          title: 'inventory_inventory-check-record',
          i18nKey: 'route.inventory_inventory-check-record'
        }
      },
      {
        name: 'inventory_inventory-info',
        path: '/inventory/inventory-info',
        component: 'view.inventory_inventory-info',
        meta: {
          title: 'inventory_inventory-info',
          i18nKey: 'route.inventory_inventory-info'
        }
      },
      {
        name: 'inventory_sales-record-info',
        path: '/inventory/sales-record-info',
        component: 'view.inventory_sales-record-info',
        meta: {
          title: 'inventory_sales-record-info',
          i18nKey: 'route.inventory_sales-record-info'
        }
      },
      {
        name: 'inventory_store-inventory-info',
        path: '/inventory/store-inventory-info',
        component: 'view.inventory_store-inventory-info',
        meta: {
          title: 'inventory_store-inventory-info',
          i18nKey: 'route.inventory_store-inventory-info'
        }
      }
    ]
  },
  {
    name: 'login',
    path: '/login/:module(pwd-login)?',
    component: 'layout.base$view.login',
    props: true,
    meta: {
      title: 'login',
      i18nKey: 'route.login',
      constant: true
    }
  },
  {
    name: 'message',
    path: '/message',
    component: 'layout.base$view.message',
    meta: {
      title: 'message',
      i18nKey: 'route.message'
    }
  },
  {
    name: 'order',
    path: '/order',
    component: 'layout.base',
    meta: {
      title: 'order',
      i18nKey: 'route.order'
    },
    children: [
      {
        name: 'order_film-purchase-credit',
        path: '/order/film-purchase-credit',
        component: 'view.order_film-purchase-credit',
        meta: {
          title: 'order_film-purchase-credit',
          i18nKey: 'route.order_film-purchase-credit'
        }
      },
      {
        name: 'order_film-purchase-order-payment-log',
        path: '/order/film-purchase-order-payment-log',
        component: 'view.order_film-purchase-order-payment-log',
        meta: {
          title: 'order_film-purchase-order-payment-log',
          i18nKey: 'route.order_film-purchase-order-payment-log'
        }
      },
      {
        name: 'order_order-evaluation',
        path: '/order/order-evaluation',
        component: 'view.order_order-evaluation',
        meta: {
          title: 'order_order-evaluation',
          i18nKey: 'route.order_order-evaluation'
        }
      },
      {
        name: 'order_order-info',
        path: '/order/order-info',
        component: 'view.order_order-info',
        meta: {
          title: 'order_order-info',
          i18nKey: 'route.order_order-info'
        }
      },
      {
        name: 'order_store-outbound-order',
        path: '/order/store-outbound-order',
        component: 'view.order_store-outbound-order',
        meta: {
          title: 'order_store-outbound-order',
          i18nKey: 'route.order_store-outbound-order'
        }
      },
      {
        name: 'order_store-purchase-order',
        path: '/order/store-purchase-order',
        component: 'view.order_store-purchase-order',
        meta: {
          title: 'order_store-purchase-order',
          i18nKey: 'route.order_store-purchase-order'
        }
      },
      {
        name: 'order_store-sale-order',
        path: '/order/store-sale-order',
        component: 'view.order_store-sale-order',
        meta: {
          title: 'order_store-sale-order',
          i18nKey: 'route.order_store-sale-order'
        }
      },
      {
        name: 'order_store-sale-order-payment-log',
        path: '/order/store-sale-order-payment-log',
        component: 'view.order_store-sale-order-payment-log',
        meta: {
          title: 'order_store-sale-order-payment-log',
          i18nKey: 'route.order_store-sale-order-payment-log'
        }
      },
      {
        name: 'order_store-warranty-order',
        path: '/order/store-warranty-order',
        component: 'view.order_store-warranty-order',
        meta: {
          title: 'order_store-warranty-order',
          i18nKey: 'route.order_store-warranty-order'
        }
      }
    ]
  },
  {
    name: 'report-platform',
    path: '/report-platform',
    component: 'layout.base',
    meta: {
      title: 'report-platform',
      i18nKey: 'route.report-platform'
    },
    children: [
      {
        name: 'report-platform_customer-distribution',
        path: '/report-platform/customer-distribution',
        component: 'view.report-platform_customer-distribution',
        meta: {
          title: 'report-platform_customer-distribution',
          i18nKey: 'route.report-platform_customer-distribution'
        }
      },
      {
        name: 'report-platform_inventory-statistics',
        path: '/report-platform/inventory-statistics',
        component: 'view.report-platform_inventory-statistics',
        meta: {
          title: 'report-platform_inventory-statistics',
          i18nKey: 'route.report-platform_inventory-statistics'
        }
      },
      {
        name: 'report-platform_order-info',
        path: '/report-platform/order-info',
        component: 'view.report-platform_order-info',
        meta: {
          title: 'report-platform_order-info',
          i18nKey: 'route.report-platform_order-info'
        }
      },
      {
        name: 'report-platform_product-sale-ranking',
        path: '/report-platform/product-sale-ranking',
        component: 'view.report-platform_product-sale-ranking',
        meta: {
          title: 'report-platform_product-sale-ranking',
          i18nKey: 'route.report-platform_product-sale-ranking'
        }
      },
      {
        name: 'report-platform_sales-amount',
        path: '/report-platform/sales-amount',
        component: 'view.report-platform_sales-amount',
        meta: {
          title: 'report-platform_sales-amount',
          i18nKey: 'route.report-platform_sales-amount'
        }
      },
      {
        name: 'report-platform_sales-analysis',
        path: '/report-platform/sales-analysis',
        component: 'view.report-platform_sales-analysis',
        meta: {
          title: 'report-platform_sales-analysis',
          i18nKey: 'route.report-platform_sales-analysis'
        }
      }
    ]
  },
  {
    name: 'report-store',
    path: '/report-store',
    component: 'layout.base',
    meta: {
      title: 'report-store',
      i18nKey: 'route.report-store'
    },
    children: [
      {
        name: 'report-store_purchase-order-credit',
        path: '/report-store/purchase-order-credit',
        component: 'view.report-store_purchase-order-credit',
        meta: {
          title: 'report-store_purchase-order-credit',
          i18nKey: 'route.report-store_purchase-order-credit'
        }
      },
      {
        name: 'report-store_purchase-order-credit-settlement',
        path: '/report-store/purchase-order-credit-settlement',
        component: 'view.report-store_purchase-order-credit-settlement',
        meta: {
          title: 'report-store_purchase-order-credit-settlement',
          i18nKey: 'route.report-store_purchase-order-credit-settlement'
        }
      },
      {
        name: 'report-store_sale-order-credit',
        path: '/report-store/sale-order-credit',
        component: 'view.report-store_sale-order-credit',
        meta: {
          title: 'report-store_sale-order-credit',
          i18nKey: 'route.report-store_sale-order-credit'
        }
      },
      {
        name: 'report-store_sale-order-credit-settlement',
        path: '/report-store/sale-order-credit-settlement',
        component: 'view.report-store_sale-order-credit-settlement',
        meta: {
          title: 'report-store_sale-order-credit-settlement',
          i18nKey: 'route.report-store_sale-order-credit-settlement'
        }
      },
      {
        name: 'report-store_statistics-customer-info',
        path: '/report-store/statistics-customer-info',
        component: 'view.report-store_statistics-customer-info',
        meta: {
          title: 'report-store_statistics-customer-info',
          i18nKey: 'route.report-store_statistics-customer-info'
        }
      },
      {
        name: 'report-store_store-employee-month-commission',
        path: '/report-store/store-employee-month-commission',
        component: 'view.report-store_store-employee-month-commission',
        meta: {
          title: 'report-store_store-employee-month-commission',
          i18nKey: 'route.report-store_store-employee-month-commission'
        }
      },
      {
        name: 'report-store_store-sale-order-commission',
        path: '/report-store/store-sale-order-commission',
        component: 'view.report-store_store-sale-order-commission',
        meta: {
          title: 'report-store_store-sale-order-commission',
          i18nKey: 'route.report-store_store-sale-order-commission'
        }
      },
      {
        name: 'report-store_transaction-records',
        path: '/report-store/transaction-records',
        component: 'view.report-store_transaction-records',
        meta: {
          title: 'report-store_transaction-records',
          i18nKey: 'route.report-store_transaction-records'
        }
      },
      {
        name: 'report-store_view-statistics-appointment-loss',
        path: '/report-store/view-statistics-appointment-loss',
        component: 'view.report-store_view-statistics-appointment-loss',
        meta: {
          title: 'report-store_view-statistics-appointment-loss',
          i18nKey: 'route.report-store_view-statistics-appointment-loss'
        }
      },
      {
        name: 'report-store_view-statistics-non-upgrade',
        path: '/report-store/view-statistics-non-upgrade',
        component: 'view.report-store_view-statistics-non-upgrade',
        meta: {
          title: 'report-store_view-statistics-non-upgrade',
          i18nKey: 'route.report-store_view-statistics-non-upgrade'
        }
      }
    ]
  },
  {
    name: 'sale-tools',
    path: '/sale-tools',
    component: 'layout.base',
    meta: {
      title: 'sale-tools',
      i18nKey: 'route.sale-tools'
    },
    children: [
      {
        name: 'sale-tools_st-category-quick',
        path: '/sale-tools/st-category-quick',
        component: 'view.sale-tools_st-category-quick',
        meta: {
          title: 'sale-tools_st-category-quick',
          i18nKey: 'route.sale-tools_st-category-quick'
        }
      },
      {
        name: 'sale-tools_st-category-section',
        path: '/sale-tools/st-category-section',
        component: 'view.sale-tools_st-category-section',
        meta: {
          title: 'sale-tools_st-category-section',
          i18nKey: 'route.sale-tools_st-category-section'
        }
      },
      {
        name: 'sale-tools_st-category-section-share',
        path: '/sale-tools/st-category-section-share',
        component: 'view.sale-tools_st-category-section-share',
        meta: {
          title: 'sale-tools_st-category-section-share',
          i18nKey: 'route.sale-tools_st-category-section-share'
        }
      },
      {
        name: 'sale-tools_st-cm-mod-item',
        path: '/sale-tools/st-cm-mod-item',
        component: 'view.sale-tools_st-cm-mod-item',
        meta: {
          title: 'sale-tools_st-cm-mod-item',
          i18nKey: 'route.sale-tools_st-cm-mod-item'
        }
      },
      {
        name: 'sale-tools_st-cm-vehicle-zones',
        path: '/sale-tools/st-cm-vehicle-zones',
        component: 'view.sale-tools_st-cm-vehicle-zones',
        meta: {
          title: 'sale-tools_st-cm-vehicle-zones',
          i18nKey: 'route.sale-tools_st-cm-vehicle-zones'
        }
      },
      {
        name: 'sale-tools_st-solution',
        path: '/sale-tools/st-solution',
        component: 'view.sale-tools_st-solution',
        meta: {
          title: 'sale-tools_st-solution',
          i18nKey: 'route.sale-tools_st-solution'
        }
      },
      {
        name: 'sale-tools_st-survey-answer',
        path: '/sale-tools/st-survey-answer',
        component: 'view.sale-tools_st-survey-answer',
        meta: {
          title: 'sale-tools_st-survey-answer',
          i18nKey: 'route.sale-tools_st-survey-answer'
        }
      },
      {
        name: 'sale-tools_st-survey-option',
        path: '/sale-tools/st-survey-option',
        component: 'view.sale-tools_st-survey-option',
        meta: {
          title: 'sale-tools_st-survey-option',
          i18nKey: 'route.sale-tools_st-survey-option'
        }
      },
      {
        name: 'sale-tools_st-survey-question',
        path: '/sale-tools/st-survey-question',
        component: 'view.sale-tools_st-survey-question',
        meta: {
          title: 'sale-tools_st-survey-question',
          i18nKey: 'route.sale-tools_st-survey-question'
        }
      },
      {
        name: 'sale-tools_st-survey-quick',
        path: '/sale-tools/st-survey-quick',
        component: 'view.sale-tools_st-survey-quick',
        meta: {
          title: 'sale-tools_st-survey-quick',
          i18nKey: 'route.sale-tools_st-survey-quick'
        }
      },
      {
        name: 'sale-tools_st-survey-share',
        path: '/sale-tools/st-survey-share',
        component: 'view.sale-tools_st-survey-share',
        meta: {
          title: 'sale-tools_st-survey-share',
          i18nKey: 'route.sale-tools_st-survey-share'
        }
      },
      {
        name: 'sale-tools_st-user-tracking',
        path: '/sale-tools/st-user-tracking',
        component: 'view.sale-tools_st-user-tracking',
        meta: {
          title: 'sale-tools_st-user-tracking',
          i18nKey: 'route.sale-tools_st-user-tracking'
        }
      },
      {
        name: 'sale-tools_store-info-edit',
        path: '/sale-tools/store-info-edit',
        component: 'view.sale-tools_store-info-edit',
        meta: {
          title: 'sale-tools_store-info-edit',
          i18nKey: 'route.sale-tools_store-info-edit'
        }
      }
    ]
  },
  {
    name: 'school',
    path: '/school',
    component: 'layout.base',
    meta: {
      title: 'school',
      i18nKey: 'route.school'
    },
    children: [
      {
        name: 'school_lecture-category',
        path: '/school/lecture-category',
        component: 'view.school_lecture-category',
        meta: {
          title: 'school_lecture-category',
          i18nKey: 'route.school_lecture-category'
        }
      },
      {
        name: 'school_lecture-course',
        path: '/school/lecture-course',
        component: 'view.school_lecture-course',
        meta: {
          title: 'school_lecture-course',
          i18nKey: 'route.school_lecture-course'
        }
      },
      {
        name: 'school_study-record',
        path: '/school/study-record',
        component: 'view.school_study-record',
        meta: {
          title: 'school_study-record',
          i18nKey: 'route.school_study-record'
        }
      }
    ]
  },
  {
    name: 'statistics',
    path: '/statistics',
    component: 'layout.base',
    meta: {
      title: 'statistics',
      i18nKey: 'route.statistics'
    },
    children: [
      {
        name: 'statistics_factory-sales-statistics',
        path: '/statistics/factory-sales-statistics',
        component: 'view.statistics_factory-sales-statistics',
        meta: {
          title: 'statistics_factory-sales-statistics',
          i18nKey: 'route.statistics_factory-sales-statistics'
        }
      }
    ]
  },
  {
    name: 'store',
    path: '/store',
    component: 'layout.base',
    meta: {
      title: 'store',
      i18nKey: 'route.store'
    },
    children: [
      {
        name: 'store_circulation-info',
        path: '/store/circulation-info',
        component: 'view.store_circulation-info',
        meta: {
          title: 'store_circulation-info',
          i18nKey: 'route.store_circulation-info'
        }
      },
      {
        name: 'store_commission-rule',
        path: '/store/commission-rule',
        component: 'view.store_commission-rule',
        meta: {
          title: 'store_commission-rule',
          i18nKey: 'route.store_commission-rule'
        }
      },
      {
        name: 'store_commission-rule-partner',
        path: '/store/commission-rule-partner',
        component: 'view.store_commission-rule-partner',
        meta: {
          title: 'store_commission-rule-partner',
          i18nKey: 'route.store_commission-rule-partner'
        }
      },
      {
        name: 'store_commission-rule-product-info',
        path: '/store/commission-rule-product-info',
        component: 'view.store_commission-rule-product-info',
        meta: {
          title: 'store_commission-rule-product-info',
          i18nKey: 'route.store_commission-rule-product-info'
        }
      },
      {
        name: 'store_commission-rule-product-sku',
        path: '/store/commission-rule-product-sku',
        component: 'view.store_commission-rule-product-sku',
        meta: {
          title: 'store_commission-rule-product-sku',
          i18nKey: 'route.store_commission-rule-product-sku'
        }
      },
      {
        name: 'store_commission-rule-sale-price',
        path: '/store/commission-rule-sale-price',
        component: 'view.store_commission-rule-sale-price',
        meta: {
          title: 'store_commission-rule-sale-price',
          i18nKey: 'route.store_commission-rule-sale-price'
        }
      },
      {
        name: 'store_film-purchase-order',
        path: '/store/film-purchase-order',
        component: 'view.store_film-purchase-order',
        meta: {
          title: 'store_film-purchase-order',
          i18nKey: 'route.store_film-purchase-order'
        }
      },
      {
        name: 'store_material-item',
        path: '/store/material-item',
        component: 'view.store_material-item',
        meta: {
          title: 'store_material-item',
          i18nKey: 'route.store_material-item'
        }
      },
      {
        name: 'store_material-transaction',
        path: '/store/material-transaction',
        component: 'view.store_material-transaction',
        meta: {
          title: 'store_material-transaction',
          i18nKey: 'route.store_material-transaction'
        }
      },
      {
        name: 'store_material-type',
        path: '/store/material-type',
        component: 'view.store_material-type',
        meta: {
          title: 'store_material-type',
          i18nKey: 'route.store_material-type'
        }
      },
      {
        name: 'store_member-info',
        path: '/store/member-info',
        component: 'view.store_member-info',
        meta: {
          title: 'store_member-info',
          i18nKey: 'route.store_member-info'
        }
      },
      {
        name: 'store_member-service-package',
        path: '/store/member-service-package',
        component: 'view.store_member-service-package',
        meta: {
          title: 'store_member-service-package',
          i18nKey: 'route.store_member-service-package'
        }
      },
      {
        name: 'store_member-vehicle-info',
        path: '/store/member-vehicle-info',
        component: 'view.store_member-vehicle-info',
        meta: {
          title: 'store_member-vehicle-info',
          i18nKey: 'route.store_member-vehicle-info'
        }
      },
      {
        name: 'store_service-item',
        path: '/store/service-item',
        component: 'view.store_service-item',
        meta: {
          title: 'store_service-item',
          i18nKey: 'route.store_service-item'
        }
      },
      {
        name: 'store_service-item-template',
        path: '/store/service-item-template',
        component: 'view.store_service-item-template',
        meta: {
          title: 'store_service-item-template',
          i18nKey: 'route.store_service-item-template'
        }
      },
      {
        name: 'store_service-package',
        path: '/store/service-package',
        component: 'view.store_service-package',
        meta: {
          title: 'store_service-package',
          i18nKey: 'route.store_service-package'
        }
      },
      {
        name: 'store_service-type',
        path: '/store/service-type',
        component: 'view.store_service-type',
        meta: {
          title: 'store_service-type',
          i18nKey: 'route.store_service-type'
        }
      },
      {
        name: 'store_service-type-template',
        path: '/store/service-type-template',
        component: 'view.store_service-type-template',
        meta: {
          title: 'store_service-type-template',
          i18nKey: 'route.store_service-type-template'
        }
      },
      {
        name: 'store_store-audit-record',
        path: '/store/store-audit-record',
        component: 'view.store_store-audit-record',
        meta: {
          title: 'store_store-audit-record',
          i18nKey: 'route.store_store-audit-record'
        }
      },
      {
        name: 'store_store-customer',
        path: '/store/store-customer',
        component: 'view.store_store-customer',
        meta: {
          title: 'store_store-customer',
          i18nKey: 'route.store_store-customer'
        }
      },
      {
        name: 'store_store-info',
        path: '/store/store-info',
        component: 'view.store_store-info',
        meta: {
          title: 'store_store-info',
          i18nKey: 'route.store_store-info'
        }
      },
      {
        name: 'store_store-sale-order-circulation',
        path: '/store/store-sale-order-circulation',
        component: 'view.store_store-sale-order-circulation',
        meta: {
          title: 'store_store-sale-order-circulation',
          i18nKey: 'route.store_store-sale-order-circulation'
        }
      },
      {
        name: 'store_store-supplier-info',
        path: '/store/store-supplier-info',
        component: 'view.store_store-supplier-info',
        meta: {
          title: 'store_store-supplier-info',
          i18nKey: 'route.store_store-supplier-info'
        }
      }
    ]
  },
  {
    name: 'sys',
    path: '/sys',
    component: 'layout.base',
    meta: {
      title: 'sys',
      i18nKey: 'route.sys'
    },
    children: [
      {
        name: 'sys_account',
        path: '/sys/account',
        component: 'view.sys_account',
        meta: {
          title: 'sys_account',
          i18nKey: 'route.sys_account'
        }
      },
      {
        name: 'sys_biz-attachment-type',
        path: '/sys/biz-attachment-type',
        component: 'view.sys_biz-attachment-type',
        meta: {
          title: 'sys_biz-attachment-type',
          i18nKey: 'route.sys_biz-attachment-type'
        }
      },
      {
        name: 'sys_data-filter',
        path: '/sys/data-filter',
        component: 'view.sys_data-filter',
        meta: {
          title: 'sys_data-filter',
          i18nKey: 'route.sys_data-filter'
        }
      },
      {
        name: 'sys_department',
        path: '/sys/department',
        component: 'view.sys_department',
        meta: {
          title: 'sys_department',
          i18nKey: 'route.sys_department'
        }
      },
      {
        name: 'sys_dict',
        path: '/sys/dict',
        component: 'view.sys_dict',
        meta: {
          title: 'sys_dict',
          i18nKey: 'route.sys_dict'
        }
      },
      {
        name: 'sys_dict-extra',
        path: '/sys/dict-extra',
        component: 'view.sys_dict-extra',
        meta: {
          title: 'sys_dict-extra',
          i18nKey: 'route.sys_dict-extra'
        }
      },
      {
        name: 'sys_gen-entity',
        path: '/sys/gen-entity',
        component: 'view.sys_gen-entity',
        meta: {
          title: 'sys_gen-entity',
          i18nKey: 'route.sys_gen-entity'
        }
      },
      {
        name: 'sys_menu',
        path: '/sys/menu',
        component: 'view.sys_menu',
        meta: {
          title: 'sys_menu',
          i18nKey: 'route.sys_menu'
        }
      },
      {
        name: 'sys_miniapp',
        path: '/sys/miniapp',
        component: 'view.sys_miniapp',
        meta: {
          title: 'sys_miniapp',
          i18nKey: 'route.sys_miniapp'
        }
      },
      {
        name: 'sys_role',
        path: '/sys/role',
        component: 'view.sys_role',
        meta: {
          title: 'sys_role',
          i18nKey: 'route.sys_role'
        }
      }
    ]
  },
  {
    name: 'user-center',
    path: '/user-center',
    component: 'layout.base$view.user-center',
    meta: {
      title: 'user-center',
      i18nKey: 'route.user-center'
    }
  }
];
